/**
 * @generated SignedSource<<1cfaea38271fa6b1bc4827cba7aeaa56>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type AutomatedNotificationType = "ABANDONED_BROWSE" | "ABANDONED_CART" | "ABANDONED_CHECKOUT" | "REENGAGEMENT" | "WELCOME_SERIES" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type AutomatedNotificationsForm_automatedNotifications$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly audiences: ReadonlyArray<{
        readonly audienceId: string;
      }> | null;
      readonly delaySeconds: number;
      readonly id: string;
      readonly isEnabled: boolean;
      readonly landingPath: string | null;
      readonly message: string;
      readonly notifType: AutomatedNotificationType;
      readonly title: string;
    };
  }>;
  readonly " $fragmentType": "AutomatedNotificationsForm_automatedNotifications";
};
export type AutomatedNotificationsForm_automatedNotifications$key = {
  readonly " $data"?: AutomatedNotificationsForm_automatedNotifications$data;
  readonly " $fragmentSpreads": FragmentRefs<"AutomatedNotificationsForm_automatedNotifications">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AutomatedNotificationsForm_automatedNotifications",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLAutomatedNotificationEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLAutomatedNotification",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "notifType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "message",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isEnabled",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "delaySeconds",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "landingPath",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "GraphQLCDPAudience",
              "kind": "LinkedField",
              "name": "audiences",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "audienceId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "GraphQLAutomatedNotificationConnection",
  "abstractKey": null
};

(node as any).hash = "c76d25f56275c337837c5116457fef7c";

export default node;
